import { render, staticRenderFns } from "./DeleteStaffPopup.vue?vue&type=template&id=00259dea&scoped=true&"
import script from "./DeleteStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteStaffPopup.vue?vue&type=style&index=0&id=00259dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00259dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00259dea')) {
      api.createRecord('00259dea', component.options)
    } else {
      api.reload('00259dea', component.options)
    }
    module.hot.accept("./DeleteStaffPopup.vue?vue&type=template&id=00259dea&scoped=true&", function () {
      api.rerender('00259dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteStaffPopup.vue"
export default component.exports